import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    flex: 1 1 280px;
    max-width: 500px;
    height: 56px;
    min-width: 0;

    @media (max-width: 768px) {
        flex: 1 1 100%;
        max-width: 100%;
        width: 100%;
        justify-content: stretch;
        height: 48px;
    }

    .search {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        max-width: 500px;
        min-width: 0;
        height: 56px;
        padding: 16px;
        background: ${({ theme }) => theme.colors.interfacePure0};
        border-radius: 8px;
        box-sizing: border-box;
        input {
            flex: 1;
            min-width: 0;
            width: 100%;
            border: none;
            outline: none;
        }

        @media (max-width: 768px) {
            max-width: none;
            height: 48px;
            padding: 12px 16px;
            input {
                flex: 1;
                min-width: 0;
                width: 100%;
            }
        }

        .buscar {
            cursor: pointer;
        }

        .clean-search {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.interfaceText300};
                }
                &:hover {
                    cursor: pointer;
                    path {
                        fill: ${({ theme }) => theme.colors.interfaceText500};
                    }
                }
            }
        }
    }
`;
